"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SimpleConstraintBuilder_1 = require("./SimpleConstraintBuilder");

var SimpleConstraintConverter_1 = require("./SimpleConstraintConverter");
/**
 * Default implementation of {@link SimpleConstraintConverter}.
 *
 * @author RV
 */


var SimpleConstraintConverterImpl =
/*#__PURE__*/
function (_SimpleConstraintConv) {
  _inherits(SimpleConstraintConverterImpl, _SimpleConstraintConv);

  function SimpleConstraintConverterImpl() {
    _classCallCheck(this, SimpleConstraintConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleConstraintConverterImpl).apply(this, arguments));
  }

  _createClass(SimpleConstraintConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      // TODO aplicate data dictionary
      return new SimpleConstraintBuilder_1.SimpleConstraintBuilder(this.deserializeConstraintType(source, conversions), conversions.toBigNumber(source.value)).build();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        value: conversions.fromBigNumber(source.value),
        constraintType: source.getType()
      });
      return result;
    }
  }]);

  return SimpleConstraintConverterImpl;
}(SimpleConstraintConverter_1.SimpleConstraintConverter);

exports.SimpleConstraintConverterImpl = SimpleConstraintConverterImpl;